<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_diabetes_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card investigations-card">
        <div class="investigations-header">
          <div class="header-left">
           📝
            <div>
              <h3>Doctors Notes</h3>
              <small class="text-muted">
                Doctor's Notes for this patient
              </small>
            </div>
          </div>

          <button class="btn btn-outline-primary" @click="showDocNotesModal">
            ✍ Add Notes
          </button>
        </div>

        <div v-if="loading">
          <loader />
        </div>

        <div v-if="!loading" class="card-body">
          <div class="table-responsive">
            <div style="max-width: 700px" class="card">
              <div
                style="
                  background-color: rgb(232, 228, 227);
                  margin-bottom: 1px;
                  border-radius: 0.7em;
                "
                class="row"
                v-for="note in notes"
                :key="note.id"
              >
                <div class="col-sm-1">#</div>
                <div class="col-sm-11">
                  <div>
                    <p style="color: black" class="pb-0 mb-0">
                      {{ note.note }}
                    </p>
                    <p style="text-align: end">
                      <span style="color: grey; font-size: smaller">
                        {{ change_utc(note.created_at) }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <table class="table investigations-table">
              <tbody>
                <tr v-if="notes.length == 0">
                  <td class="text-center text-muted py-4">
                    No Notes added for this patient
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <add_doctors_note_modal
    v-if="showNotesModal"
    @close-add-doc-note-modal="closeNotesModal"
    :visit_id="visit_id"
    @note-added="refresh"
  />
</template>

<script>
import add_doctors_note_modal from "../../visits_management/consultation/add_doctors_note_modal.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import utc_local_time from "../../../timezone/utc_local_time";

import full_diabetes_head from "./full_diabetes_head.vue";

export default {
  name: "PatientInvestigations",
  components: {
    full_diabetes_head,
    add_doctors_note_modal,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,

      showNotesModal: false,
      notes: [],
    };
  },
  methods: {
    change_utc(utc) {
      return utc_local_time(utc);
    },
    closeNotesModal() {
      this.showNotesModal = false;
    },
    showDocNotesModal() {
      this.showNotesModal = true;
    },
    refresh() {
      this.fetchDoctorsNotes();
    },
    async fetchDoctorsNotes() {
      try {
        const url = `doctors-notes/${this.visit_id}`;
        const res = await generalApiRequest(url, "GET", {}, 1);
        if (res && res.status === "success") {
          this.notes = res.data;
        }
      } catch (error) {
        console.error("Failed to fetch doctor’s notes:", error);
      }
    },
  },
  mounted() {
    this.fetchDoctorsNotes();
  },
};
</script>

<style scoped>
/* Card */
.investigations-card {
  margin-top: 20px;
  border-radius: 8px;
  border-left: 5px solid #0d6efd;
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

/* Header */
.investigations-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #dee2e6;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  font-size: 26px;
  color: #0d6efd;
}

/* Table */
.investigations-table {
  font-size: 0.95rem;
}

.investigations-table thead th {
  background: #fafbfc;
  font-weight: 600;
  color: #495057;
}

/* Type pills */
.type-pill {
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: 600;
}

.type-lab {
  background: #e7f1ff;
  color: #0d6efd;
}

.type-xray {
  background: #f1f3f5;
  color: #495057;
}

.type-ct {
  background: #fff3cd;
  color: #856404;
}

.type-mri {
  background: #e2e3f3;
  color: #3f51b5;
}

/* Status dots */
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-ordered {
  background: #6c757d;
}

.dot-sample {
  background: #fd7e14;
}

.dot-reported {
  background: #0d6efd;
}

.dot-reviewed {
  background: #198754;
}

.status-text {
  font-size: 0.85rem;
}

/* Buttons */
.btn-light {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.btn-light:hover {
  background: #e9ecef;
}

/* Responsive */
@media (max-width: 768px) {
  .investigations-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
